// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Wq67O","modal__close-icon":"modal_modal__close-icon__Dg0X3"};